import { SubmissionError, reset } from 'redux-form';
import { call, put, takeLatest } from 'redux-saga/effects'

import Api from '../../Api'
import mixpanel from 'mixpanel-browser'
import { push } from 'connected-react-router'

export const types = {
    FETCH_EMAIL: 'SIGNUP/FETCH_EMAIL',
    LOAD_DATA: 'SIGNUP/LOAD_DATA',
    BAD_TOKEN: 'SIGNUP/BAD_TOKEN',
    SUBMIT: 'SIGNUP/SUBMIT',
    CHANGE_PAGE: 'SIGNUP/CHANGE_PAGE'
}

export const actions = {
    fetchEmail: (token) => ({ type: types.FETCH_EMAIL, token }),
    loadData: (data, newUser=false) => ({ type: types.LOAD_DATA, data, newUser }),
    badToken: () => ({ type: types.BAD_TOKEN }),
    submit: (params, reject, resolve) => ({ type: types.SUBMIT, params, reject, resolve }),
    changePage: (delta) => ({ type: types.CHANGE_PAGE, delta })
}

export const initialState = {
    page: 1,
    loading: true,
    newUser: true,
    initialValues: {        
        email: '',
    }
}

export default (state = initialState, action) => {
    switch (action.type) {
        case types.LOAD_DATA:
            return {
                ...state,
                page:1,
                newUser: action.newUser,
                initialValues: action.data,
                loading: false,
            }
        case types.BAD_TOKEN:
            return {
                ...state,
                loading: false,
                page: 0,
            }
        case types.CHANGE_PAGE:
            return {
                ...state,
                loading: false,
                page: state.page + action.delta,
            }
        default:
            return state
    }
}

/* Sagas */
export function* fetchEmail(action) {
    try {
        if (action.token !== 'existing-user') {
            const res = yield call(Api.fetchTrialEmail, action.token);
            res.token = action.token; // embedd token in the form 
            yield put(actions.loadData(res, true));
        }
    } catch (e) {
        yield put(actions.badToken());
    }
}

export function* submit(action) {
    try {
        if (!action.params.validate_only) {
            mixpanel.track('AcceptedEULA', { Flow: 'Trial' });
        }
        yield call(Api.sumbitTrialUserDetails, action.params);
        yield call(action.resolve);
        if (action.params.validate_only) {
            yield put(actions.changePage(1));
            mixpanel.track('SubmittedSignupForm', { Flow: 'Trial' });
        } else {
            yield put(reset('SignupForm'));
            mixpanel.track('TrialSignup');
            yield put(push('/'));
        }
    } catch (e) {
        if (e.response !== undefined) {
            let errors = e.response.data;
            mixpanel.track('SubmittedSignupFormError', { Flow: 'Trial', Error: errors });

            yield call(action.reject, new SubmissionError(errors));
        } else {
            yield call(action.reject);
        }
    }
}


export function* signupFlow() {
    yield takeLatest(types.FETCH_EMAIL, fetchEmail);
    yield takeLatest(types.SUBMIT, submit);
}
